export enum AgentStatusType {
  OnDuty = "OnDuty",
  OnDutyOnBreak = "OnDutyOnBreak",
  OffDuty = "OffDuty"
}
